import React from 'react';
import { BsLinkedin } from 'react-icons/bs';

const SocialMedia = () => {
  return (
    <div className="app__social">
        <div>
        <a href="https://www.linkedin.com/in/mack-mraz/">
            <BsLinkedin />
          </a>
        </div>
    </div>
  )
}

export default SocialMedia